const QaSStatus = {
  NEW: 0,
  CONCLUDED: 2,
};

export default QaSStatus;
